import {useSelector} from 'react-redux';

import mwFwuService from '@/services/mw/mwFwuService';
import {selectIsHolderConnectedToIot} from '@/state/selectors/device';

const useFwuManualChecker = () => {
    const isHolderConnectedToIot = useSelector(selectIsHolderConnectedToIot);

    return () =>
        Promise.all([
            mwFwuService.checkFwuAvailability(),
            isHolderConnectedToIot && mwFwuService.checkFwuAvailability(true),
        ]);
};

export default useFwuManualChecker;
